import { throttle } from '@neux/ui-jquery/tool';

export default function () {
  let scrollVal = 0;
  throttle(
    $(window).on('scroll', function () {
      let nowTop = $(this).scrollTop();
      if (scrollVal > nowTop && nowTop > 100) {
        // 往上
        $('body, .header').addClass('scroll-up');
      } else {
        $('body, .header').removeClass('scroll-up');
      }
      scrollVal = nowTop;
    })
  )
}